import SiteLayout from '@/components/feature/SiteLayout';
import useSeo, { SITE_NAME, SITE_ORIGIN } from '@/hooks/useSeo';
import { siteFaqs } from '@/mocks/cases';
import Hero from './components/Hero';
import HotCases from './components/HotCases';
import CategoryGrid from './components/CategoryGrid';
import EvidenceSection from './components/EvidenceSection';
import ProcessSection from './components/ProcessSection';
import Testimonials from './components/Testimonials';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  useSeo({
    title: '网红爆料网 - 实锤证据 录音 视频证据 合同照片 转账记录',
    description:
      '网红爆料网坚持实锤为本，集中展示录音、视频证据、合同照片与转账记录。每条爆料都附原始材料与核实状态，覆盖直播圈、带货电商、MCN 合约等热门话题。',
    keywords: '网红爆料,网红爆料实锤,网红爆料证据,网红爆料录音,网红爆料视频证据,网红爆料合同照片',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE_NAME,
        url: SITE_ORIGIN,
        description: '以实锤证据为核心的中文网络爆料资讯门户，收录录音、视频证据、合同照片与转账记录。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_ORIGIN}/cases?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: SITE_NAME,
        url: SITE_ORIGIN,
        email: 'contact@baoliao.example.com',
        description: '坚持实锤为本的网络爆料内容整理与核实平台。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: siteFaqs.map((faq) => ({
          '@type': 'Question',
          name: faq.q,
          acceptedAnswer: { '@type': 'Answer', text: faq.a },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <Hero />
      <HotCases />
      <CategoryGrid />
      <EvidenceSection />
      <ProcessSection />
      <Testimonials />
      <FaqSection />
      <CtaSection />
    </SiteLayout>
  );
}